var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"bar",attrs:{"width":"20vw","tile":"","elevation":"0 pa-0","color":"rgba(0,0,0,0)"}},[_c('v-card',{staticClass:"bar",attrs:{"width":`${_vm.percentage}%`,"elevation":"0","color":_vm.color}},[_c('span',[_c('br')])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }